<template>
    <modal>
        <div class="modal_preloader">
            <div id="preloader" class="active">
                <img src="@/assets/img/loader.svg" alt="" width="64" height="64" class="loader-spin">
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "../views/Modal";
    export default {
        name: "ModalPreloader",
        components: {Modal},
        computed: {
        }
    }
</script>